export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";